import React, { useEffect, useState } from 'react';
import { MdContentCopy } from 'react-icons/md';
import { BaSeBackendNoSignalPage, BaSeIcon } from '@base/react';
import {
  BlackList,
  ErroEnvioSAS,
  HabilitarDiagnostico,
  ProjetosAcoes,
  RegrasContabilizacao,
  SolicitacaoDeVinculo,
  TipoRegistro,
  VersaoApp,
  AtendimentoRecusado,
  EventoSebrae,
} from './components';

import './styles.css';
import {
  FlexDirectionRow,
  MainContainer,
  Title,
} from '../../components/StyledComponents';
import { useHistory, useLocation } from 'react-router-dom';
import { useApp } from '../../context/app';
import { AgentesSSE } from './components/AgentesSSE';
import { ManutencaoApp } from './components/ManutencaoApp';
import { DevolutivaPadrao } from './components/DevolutivaPadrao';
import { ConsultarEmpreendedor } from './components/ConsultarEmpreendedor';
import { useRouteMatch } from 'react-router';
import { hasAdminRole, hasGestorSSERole } from '../../utils/hasPermission';
import { EditarAtendimento } from './components/EditarAtendimento';
import { CanaisDigitais } from './components/CanaisDigitais';
import { SolucoesSebrae } from './components/SolucoesSebrae';

const SCREENS = [
  {
    id: 'TipoRegistro',
    component: <TipoRegistro />,
    label: 'Atendimento: tipo de registro',
  },
  {
    id: 'RegrasContabilizacao',
    component: <RegrasContabilizacao />,
    label: 'Atendimento: regras de contabilização',
  },
  {
    id: 'ProjetosAcoes',
    component: <ProjetosAcoes />,
    label: 'Atendimento: projeto e ações',
  },
  {
    id: 'AgentesSSE',
    component: <AgentesSSE />,
    label: 'Atendimento: agentes SSE',
    allowAccessGestorSSE: true,
  },
  {
    id: 'ErroEnvioSAS',
    component: <ErroEnvioSAS />,
    label: 'Atendimento: erros envio SAS',
    allowAccessGestorSSE: true,
  },
  {
    id: 'Diagnostico',
    component: <HabilitarDiagnostico />,
    label: 'Diagnóstico: habilitar no App',
  },
  {
    id: 'SolicitacaoDeVinculo',
    component: <SolicitacaoDeVinculo />,
    label: 'Empresa: solicitação de vínculo',
  },
  {
    id: 'VersaoApp',
    component: <VersaoApp />,
    label: 'Versionamento do App',
  },
  {
    id: 'EventoSebrae',
    component: <EventoSebrae />,
    label: 'Eventos Sebrae',
  },
  {
    id: 'ManutencaoApp',
    component: <ManutencaoApp />,
    label: 'App: serviço em manutenção',
  },
  {
    id: 'DevolutivaPadrao',
    component: <DevolutivaPadrao />,
    label: 'Diagnóstico: devolutiva padrão',
  },
  {
    id: 'Blacklist',
    component: <BlackList />,
    label: 'SAS: blacklist SSE',
  },
  {
    id: 'ConsultarEmpreendedor',
    component: <ConsultarEmpreendedor />,
    label: 'Consultar Empreendedor',
  },
  {
    id: 'AtendimentoRecusado',
    component: <AtendimentoRecusado />,
    label: 'Atendimento: CNPJ recusou',
    allowAccessGestorSSE: true,
  },
  {
    id: 'EditarAtendimento',
    component: <EditarAtendimento />,
    label: 'Atendimento: edição de registros',
    allowAccessGestorSSE: true,
  },
  {
    id: 'CanaisDigitais',
    component: <CanaisDigitais />,
    label: 'Atendimento: canais digitais',
    allowAccessGestorSSE: true,
  },
  {
    id: 'SolucoesSebrae',
    component: <SolucoesSebrae />,
    label: 'Atendimento: soluções Sebrae',
    allowAccessGestorSSE: true,
  },
];

const TabelasDeControle = () => {
  const {
    setRenderIncludeScreen,
    setManageItem,
    renderIncludeScreen,
  } = useApp();
  const location = useLocation();
  const history = useHistory();
  const [error] = useState(false);
  const [optionSelected, setOptionSelected] = useState('');
  const match = useRouteMatch('/tabelas-de-controle/:tableId?');
  const tableId = match?.params?.tableId;
  const [menus, setMenus] = useState([]);

  const withoutIncludeButton = [
    'ErroEnvioSAS',
    'DevolutivaPadrao',
    'SolicitacaoDeVinculo',
    'Blacklist',
    'ConsultarEmpreendedor',
    'AtendimentoRecusado',
    // 'EditarAtendimento',
  ];

  useEffect(() => {
    const handleMenus = async () => {
      const isAdminRole = await hasAdminRole();
      const isGestorSSERole = await hasGestorSSERole();
      const filteredMenus = isAdminRole
        ? SCREENS
        : SCREENS.filter((s) => s.allowAccessGestorSSE && isGestorSSERole);
      setMenus(filteredMenus);
    };
    handleMenus();
  }, []);

  useEffect(() => {
    const setInitialOption = async () => {
      const isAdminRole = await hasAdminRole();
      const isGestorSSERole = await hasGestorSSERole();
      if (isAdminRole) {
        const firstOption = tableId ?? SCREENS[0]?.id;
        setOptionSelected(firstOption);
      } else {
        const tableIdScreen = SCREENS.find((s) => (tableId === s.id))?.id;
        const firstScreenGestorSSE = SCREENS.find((s) => isGestorSSERole && s.allowAccessGestorSSE)?.id;
        const option = tableIdScreen ?? firstScreenGestorSSE;
        setOptionSelected(option);
      }
    };
    setInitialOption();
  }, [tableId, withoutIncludeButton, history]);

  const renderScreen = SCREENS.find((s) => s.id === optionSelected)?.component;

  const handleClickBack = () => {
    setRenderIncludeScreen(false);
    setManageItem({});
  };

  const handleClickAdd = () => {
    setRenderIncludeScreen(true);
    setManageItem({ type: 'adicionar' });
  };


  useEffect(() => {
    setRenderIncludeScreen(false);
  }, [optionSelected, setRenderIncludeScreen]);

  const handleChangeSelect = (event) => {
    location.state = null;
    const value = event?.target?.value;
    const url = `/tabelas-de-controle/${value}`;
    history.push(url);
    setOptionSelected(value);
  };

  if (error) {
    return <BaSeBackendNoSignalPage />;
  }

  return (
    <>
      <MainContainer backgroundColor={'#0061C6'}>
        <FlexDirectionRow>
          <FlexDirectionRow style={{ width: '100%' }}>
            <MdContentCopy size={40} color="#ffffff" />
            <Title>Tabelas de Controle</Title>
          </FlexDirectionRow>

          <FlexDirectionRow
            position="end"
            style={{ alignItems: 'center', width: '100%' }}
          >
            <div className="selection-box">
              <select
                className="selection-box-content"
                onChange={handleChangeSelect}
                value={optionSelected}
              >
                {menus.map((s) => {
                  return (
                    <option key={s.id} value={s.id}>
                      {s.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {withoutIncludeButton.includes(optionSelected) ? (
              !!renderIncludeScreen && (
                <BaSeIcon
                  onClick={() => handleClickBack()}
                  name={'arrow-circle-left'}
                  description="Voltar"
                  color="#ffffff"
                  size={50}
                />
              )
            ) : !!renderIncludeScreen ? (
              <BaSeIcon
                onClick={() => handleClickBack()}
                name={'arrow-circle-left'}
                description="Voltar"
                color="#ffffff"
                size={50}
              />
            ) : (
              <BaSeIcon
                onClick={() => handleClickAdd()}
                name={'plus-circle'}
                description="Adicionar"
                color="#ffffff"
                size={50}
              />
            )}
          </FlexDirectionRow>
        </FlexDirectionRow>
      </MainContainer>
      {!!optionSelected && renderScreen}
    </>
  );
};

export default TabelasDeControle;
